angular.module('taric.cross', [])
    .config(['$routeProvider', routeConfigurator])
    // Components
    .component('customsRulingsButton', require('./components/customs-rulings-button'))
    .component('customsRulingDetails', require('./components/customs-ruling-details'))
    .component('customsRulingsSearchForm', require('./components/customs-rulings-search-form'))
    .component('customsRulingsList', require('./components/customs-rulings-list'))
    .component('customsRulingsSearchPage', require('./components/customs-rulings-search-page'))
    // Modals
    .factory('customsRulingsModal', require('./modals/customs-rulings-modal'))
    // Services
    .factory('crossDataService', require('./services/cross-data'))
    ;

function routeConfigurator($routeProvider) {
    $routeProvider
        .when('/customs-rulings/search', {
            reloadOnSearch: false,
            showSearchSubNav: true, 
            template: '<customs-rulings-search-page></customs-rulings-search-page>',
        })
        .when('/customs-rulings/home', {
            reloadOnSearch: false,
            showSearchSubNav: false, 
            template: '<customs-rulings-search-page></customs-rulings-search-page>',
        })
        ;
}
